import { useEffect } from "react";
import { EMPTY_MESSAGES, EMPTY_MESSAGE_IMAGES, FONTS } from "../../constants";
import Dataset from "../../MachineLearning/Dataset";
import { PCAEncoder } from "../../MachineLearning/PCAReduction";
import { stateType, stateTypeF } from "../../state";

import { useStyles } from "../DataIngestion/DataIngestion";
// import { GroupStats } from "./GroupStatsBox";
import { EmptyMessage } from "../Common/EmptyMessage";
import { CloudBox } from "./CloudBox";
import { ClusterBox } from "./ClusterBox";
import { CustomTopicTable } from "./CustomTopicTable";
import { DropDown } from "./DropDown";
import { notifyPageView } from "../../analytics/useAnalyticsEventTracker";
import { setMetaTags } from "../../helpers/pageMeta";

const MAX_POINTS = 1000;

export function calcPCA(state: stateTypeF, dataset: Dataset) {
	let mlData = dataset.getMLData(
		dataset.columns[0].columnName,
		undefined,
		undefined,
		false,
		true
	);
	let X = mlData.X.slice(0, MAX_POINTS);

	const pcaEncoder = new PCAEncoder();
	pcaEncoder.train(X);
	X = pcaEncoder.applyProjection(X);
	state.setPcaEncodedData(X);
	return X;
}

export function PersonaGroupings({ state }: stateType) {
	let classes = useStyles();
	useEffect(() => {
		setMetaTags();
		window.scrollTo(0, 0);
		notifyPageView("Clustering Page", window.location.pathname);
	}, []);

	if (state.saveState.dataset.visualizationData === undefined) {
		return (
			<EmptyMessage
				image={EMPTY_MESSAGE_IMAGES.pleaseTrain}
				message1={EMPTY_MESSAGES.noText1}
				message2={EMPTY_MESSAGES.noText2}
				button={false}
			></EmptyMessage>
		);
	}

	return (
		<div className={classes.root}>
			<div className={classes.grid}>
				<div className={classes.title}>Natural Language Processing</div>
				<div
					style={{
						display: "flex",
						marginTop: "40px",
						marginBottom: "-40px",
						marginRight: "5px",
						zIndex: 1000,
					}}
				>
					<div
						style={{
							fontSize: "18px",
							fontFamily: FONTS,
							color: "rgba(0,0,0,0.8)",
						}}
					>
						Column:{" "}
					</div>
					<DropDown state={state}></DropDown>
				</div>
			</div>
			<div className={classes.grid}>
				<div className={classes.subTitle}>
					Group similar text together, analyze their topics and
					understand your text content data better.
				</div>
			</div>
			<div className={classes.grid}>
				<ClusterBox state={state}></ClusterBox>
			</div>
			<div className={classes.divider2}></div>
			<div className={classes.grid}>
				<CustomTopicTable state={state}></CustomTopicTable>
			</div>
			<div className={classes.divider2}></div>
			<div className={classes.grid}>
				<div className={classes.title}>Top Themes</div>
			</div>
			<div className={classes.grid}>
				<CloudBox state={state}></CloudBox>
			</div>
			<div className={classes.divider2}></div>
			<div className={classes.grid}>
				<div className={classes.divider}></div>
			</div>
		</div>
	);
}
